module.exports = __webpack_public_path__ + "78a5365128d4df9c6ff2e536611d1b09.svg";